/*
 * @Descripttion: ai 中台的请求 baseurl换了 不共用
 * @version: 
 * @Author: szj
 * @Date: 2025-03-13 15:12:25
 * @LastEditors: szj
 * @LastEditTime: 2025-03-13 16:04:17
 */

import axios from 'axios'
import { CURRENT_CONFIG } from './config'
import { message } from 'ant-design-vue'
import router from '/@/router'
import { ELocalStorageKey, ERouterName, EUserType } from '/@/types/enums'
import Cookies from 'js-cookie'
export * from './type'

const REQUEST_ID = 'X-Request-Id'
function getAuthToken () {
  return Cookies.get(ELocalStorageKey.Token) || new Date().getTime()
}

const service = axios.create({
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  // timeout: 12000,
})
const baseUrl = CURRENT_CONFIG.aiBaseUrl
service.interceptors.request.use(
  config => {
    // config.headers[ELocalStorageKey.Token] = getAuthToken() // 暂时先注释
    config.baseURL = baseUrl
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

service.interceptors.response.use(
  response => {
    if (response.data.code && response.data.code !== 0) {
      // if (response.data.message == '请重新登录') {
      //   setTimeout(() => {
      //     router.push(ERouterName.PROJECT)
      //     return
      //   }, 1000);
      // }
    }
    return response
  },
  err => {
    // const requestId = err?.config?.headers && err?.config?.headers[REQUEST_ID]
    // if (requestId) {
    //   console.info(REQUEST_ID, '：', requestId)
    // }
    let description = '-'
    if (err.response?.data && err.response.data.message) {
      description = err.response.data.message
    }
    if (err.response?.data && err.response.data.result) {
      description = err.response.data.result.message
    }
    if (!err.response || !err.response.status) {
      message.error('网络异常，请检查服务，然后重试')
      return
    }
    if (err.response?.status !== 200) {
      message.error(`ERROR_CODE: ${err.response?.status}`)
    }
    // if (err.response?.status === 401) {
    //   const flag: number = Number(localStorage.getItem(ELocalStorageKey.Flag))
    //   switch (flag) {
    //     case EUserType.Web:
    //       router.push(ERouterName.PROJECT)
    //       break
    //     case EUserType.Pilot:
    //       router.push(ERouterName.PILOT)
    //       break
    //   }
    // }

    return Promise.reject(err)
  },
)
// 封装 get 请求
export function get(url:string, params = {}) {
  return service.get(url, {
      params
  });
}

// 封装 post 请求
export function post(url:string, data = {}) {
  return service.post(url, data);
}
// 封装上传文件的方法，添加进度处理
export const uploadProgressFile = (url: string, data: any, onUploadProgress: any) => {
  return service({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: onUploadProgress
  });
};

export default service
